import { Component, OnInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'router-navigation',
    templateUrl: './router-navigation.component.html',
    styleUrls: ['./router-navigation.component.scss']
})
export class RouterNavigationComponent implements OnInit, OnDestroy {

    constructor() {
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }
}
